import { render } from "./edit-actions.vue?vue&type=template&id=a3d9544c&ts=true"
import script from "./edit-actions.vue?vue&type=script&lang=ts"
export * from "./edit-actions.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__